var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { useAttrs, computed } from "vue";
function useAriaInvalid() {
  const attrs = useAttrs();
  return computed(() => attrs["aria-invalid"] === "true" || attrs["aria-invalid"] === !0);
}
__name(useAriaInvalid, "useAriaInvalid");
export {
  useAriaInvalid
};
//# sourceMappingURL=useAriaInvalid.js.map
